import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import Category  from './Category.js';
import {getNotification, isEnabled} from './tools.js';
import {initNavbarState, setNavbarTitle} from 'actions/navbar.js';
import {fetchObjectives} from 'actions/objectives.js';
import {fetchCategories, toggleSubscription, toggleNotification, updateNotification, userCategoryUpdateLevel} from 'actions/categories.js';
import {fetchChallenges, fetchDaily} from 'actions/challenges.js';
import {getObjective} from 'reducers/objectives.js';
import {getCategoryWithNotifications} from 'reducers';
import defaultCategoryImage from 'img/default-challenge-image.jpg';

class CategoriesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false, showEditFrequency:false, showEditTime:false, showEditLevel:false};
        this.onToggleSubscription= this.onToggleSubscription.bind(this);
        this.onToggleNotification= this.onToggleNotification.bind(this);
        this.updateNotification = this.updateNotification.bind(this);
        this.updateLevel = this.updateLevel.bind(this);
        this.onShowEditFrequency = this.onShowEditFrequency.bind(this);
        this.onShowEditTime = this.onShowEditTime.bind(this);
        this.onShowEditLevel = this.onShowEditLevel.bind(this);
    }

    componentWillMount() {
        var title = this.props.category!=null ? this.props.category.title : '';
        this.props.dispatch(initNavbarState({enable:true, title:title}));
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.category==null && this.props.category!=null) {
            this.props.dispatch(setNavbarTitle(this.props.category.title));
        }
    }

    loadData() {
        this.setState({busy:true});
        this.props.loadData()
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }

    onToggleSubscription(event) {
        var categoryId = event.currentTarget.getAttribute('data-id');
        this.props.toggleSubscription(Number(categoryId));
    }
    onToggleNotification(event) {
        var categoryId = event.currentTarget.getAttribute('data-id');
        this.props.toggleNotification(Number(categoryId));
    }


    getCategoryImageUrl(category) {
        if(category && category.leaderboardBanner && (category.leaderboardBanner.url||'').length>0) {
            return category.leaderboardBanner.url;
        } else {
            return defaultCategoryImage;
        }
    }

    onShowEditFrequency(show) {
        this.setState({showEditFrequency:show});
    }
    onShowEditTime(show) {
        this.setState({showEditTime:show});
    }
    onShowEditLevel(show) {
        this.setState({showEditLevel:show});
    }

    updateNotification(categoryId, notification) {
        this.props.updateNotification(categoryId, {enabled:notification.enabled, active:notification.active, defaultTime:notification.defaultTime, time:notification.time, pattern:notification.pattern});
        this.setState({showEditFrequency:false, showEditTime:false});
    }

    updateLevel(categoryId, level) {
        this.props.userCategoryUpdateLevel(categoryId, level);
        this.setState({showEditLevel:false});
    }

    render() {
        return <Category alwaysOn={this.props.match.params.on}
                         category={this.props.category}
                         showEditFrequency={this.state.showEditFrequency}
                         showEditTime={this.state.showEditTime}
                         showEditLevel={this.state.showEditLevel}
                         onShowEditFrequency={this.onShowEditFrequency}
                         onShowEditTime={this.onShowEditTime}
                         onShowEditLevel={this.onShowEditLevel}
                         onToggleSubscription={this.onToggleSubscription}
                         onToggleNotification={this.onToggleNotification}
                         updateNotification={this.updateNotification}
                         updateLevel={this.updateLevel}
                         getCategoryImageUrl={this.getCategoryImageUrl}
                         isEnabled={isEnabled(this.props.category)}
                         notification={getNotification(this.props.category)}
                         busy={this.state.busy} />;
    }

}


const mapStateToProps = (state, ownProps) => {
    var categoryId = Number(ownProps.match.params.id);
    var category = getCategoryWithNotifications(state, categoryId);
    return {category:category};
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(fetchCategories()),
        toggleSubscription: (id) => dispatch(toggleSubscription(id)),
        toggleNotification: (id) => dispatch(toggleNotification(id)),
        userCategoryUpdateLevel: (id, level) => dispatch(userCategoryUpdateLevel(id,level)),
        updateNotification: (id, notificationUpdate) => dispatch(updateNotification(id, notificationUpdate)),
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CategoriesContainer));



// WEBPACK FOOTER //
// ./src/modules/categories/CategoryContainer.js